import $ from "jquery";
import historyService from './lsag.historyService';
import utils from './lsag.utils';

const pagination = {
    backUrl: null,
    readHistory() {
        if (historyService.getState().productCode) {
            historyService.restorePos(historyService.getState().scrollTop);
            if (!utils.isPartiallyOnScreen('#' + historyService.getState().productCode)) {
                console.error('Product: ' + historyService.getState().productCode + ' is not in viewport');
            }
        }
    },

    getCurrentUrl() {
        this.backUrl = $('#masonry-grid').data('back-url');
    },
    bindEvents() {
        $('#masonry-grid').on('click', '.js-product-id', (e) => {
            let productCode = $(e.currentTarget).attr('id');
            // replaceState or pushstate, that is the question
            historyService.replaceState({
                productCode: productCode,
                scrollTop: $(window).scrollTop()
            }, this.backUrl);
        });
    }
};

// DOM ready
$(() => {
    if ($('#masonry-grid').length) {
        pagination.readHistory();
        pagination.getCurrentUrl();
        pagination.bindEvents();
    }
});

export default pagination;
